<template>
  <v-dialog :value="show" absolute max-width="600" persistent>
    <v-card>
      <v-card-title class="headline grey lighten-3">
        {{ $t('Политика безопасности персональных данных') }}
      </v-card-title>
      <v-card-text class="caption text-justify">
        <p>
          {{ $t('Заявители и Пользователи СЭТ ВР доверяют АО Петербургская Биржа обработку персональных данных, содержащихся в документах, размещенных в СЭТ ВР, с целью обеспечения функционирования СЭТ ВР и проведения Торгов. АО Петербургская Биржа может совершать с персональными данными следующие действия: сбор, запись, систематизацию, накопление, хранение, извлечение, использование, предоставление доступа, обезличивание, блокирование, удаление, уничтожение и иные действия с использованием и/или без использования средств автоматизации. АО Петербургская Биржа обязуется соблюдать принципы и правила обработки персональных данных, предусмотренные Федеральным законом №152-ФЗ от 27 июля 2006 года «О персональных данных», обеспечивать безопасность персональных данных при их обработке, а также выполнять требования к защите обрабатываемых персональных данных в соответствии со статьей 19 Федерального закона №152-ФЗ от 27 июля 2006 года «О персональных данных».') }}
        </p>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
            v-test="{ btn: 'cancel' }"
            text
            @click.stop="select(false)">
          {{ $t('Нет') }}
        </v-btn>
        <v-spacer />
        <v-btn
            v-test="{ btn: 'ok' }"
            class="textwithbackground--text"
            color="primary"
            @click.stop="select(true)">
          {{ $t('Да') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .v-card__text {
    padding-top: 20px !important;
    color: black !important;
  }
</style>

<script>
  export default {
    props: {
      value: false,
      show: false
    },
    data () {
      return {
        agreement: this.value
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          this.agreement = newVal
        }
      }
    },
    methods: {
      select: function (agreement) {
        this.$emit('input', agreement)
        this.$emit('close')
      }
    }
  }
</script>
